import { jsx as _jsx } from "react/jsx-runtime";
import noop from "lodash/noop";
import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { isDevOrTestStage } from "~/swr-hooks/utils";
import { reportErrorToBugsnag } from "~/utils/ErrorUtils";
export const VIDEO_TIMESTAMP_CONTEXT_DEFAULT_VALUE = {
    currentTime: undefined,
    handleClearTimestamp: noop,
    handleSetCurrentTime: noop,
    handleSetTimestamp: noop,
    timestamp: undefined
};
export const VideoTimestampContext = /*#__PURE__*/ createContext(VIDEO_TIMESTAMP_CONTEXT_DEFAULT_VALUE);
export const VideoTimestampProvider = (param)=>{
    let { children } = param;
    const [currentTime, setCurrentTime] = useState(undefined);
    const [timestamp, setTimestamp] = useState(undefined);
    const handleClearTimestamp = useCallback(()=>{
        setTimestamp(undefined);
    }, []);
    const handleSetCurrentTime = useCallback((time)=>{
        setCurrentTime(time);
    }, []);
    const handleSetTimestamp = useCallback((time)=>{
        setTimestamp(time !== null && time !== void 0 ? time : currentTime);
    }, [
        currentTime
    ]);
    const values = useMemo(()=>({
            currentTime,
            handleClearTimestamp,
            handleSetCurrentTime,
            handleSetTimestamp,
            timestamp
        }), [
        currentTime,
        handleClearTimestamp,
        handleSetCurrentTime,
        handleSetTimestamp,
        timestamp
    ]);
    return /*#__PURE__*/ _jsx(VideoTimestampContext.Provider, {
        value: values,
        children: children
    });
};
export const useVideoTimestampContext = ()=>{
    const context = useContext(VideoTimestampContext);
    if (context === VIDEO_TIMESTAMP_CONTEXT_DEFAULT_VALUE) {
        const error = "useVideoTimestampContext must be used within a VideoTimestampProvider";
        if (isDevOrTestStage()) {
            throw error;
        } else {
            reportErrorToBugsnag({
                error,
                context: error
            });
        }
    }
    return context;
};
